import {
  Badge,
  Body,
  Box,
  Container,
  ContainerProps,
  Heading,
} from '@hover/blueprint';
import GatsbyImage from 'gatsby-image';
import React, { FC } from 'react';
import BLOG_CATEGORIES from '../../../constants/blog-categories';
import { IBlogPost } from '../../../interfaces/IBlogPost';
import BlogPostParser from './BlogPostParser';
import BlogPostShareButtons from './BlogPostShareButtons';

interface Props {
  post: IBlogPost;
  pt?: ContainerProps['pt'];
  pb?: ContainerProps['pb'];
}

const BlogPost: FC<Props> = ({ post, pb, pt }) => {
  const postCategoryData = BLOG_CATEGORIES.find(
    item => item.value === post.categories[0],
  );
  return (
    <Container
      maxW="1248px"
      pb={pb}
      pt={pt}
      overflow="hidden"
      pl={500}
      pr={{ base: 500, desktop: 0 }}
    >
      <Box display="flex" flexDirection={{ base: 'column', tablet: 'row' }}>
        <Box
          display="flex"
          flexDirection="column"
          width={{ base: '100%', tablet: '28%' }}
        >
          {postCategoryData ? (
            <Box pb={{ base: 500, tablet: 800 }}>
              <Badge
                colorScheme={postCategoryData.color}
                variant="brand"
                textTransform="uppercase"
              >
                {postCategoryData.value}
              </Badge>
            </Box>
          ) : null}
          {post?.author ? (
            <Box pb={{ base: 400, tablet: 500 }}>
              <Body
                color="neutral.700"
                size={{ base: 300, table: 500 }}
                fontStyle="italic"
              >
                {post.author}
              </Body>
            </Box>
          ) : null}
          <Body
            pb={{ base: 500, tablet: '80px' }}
            color="neutral.700"
            size={300}
          >
            {post.publishDate}
          </Body>
          <Box display={{ base: 'none', tablet: 'block' }}>
            <BlogPostShareButtons />
          </Box>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          width={{ base: '100%', tablet: '75%' }}
        >
          <Box display="flex" flexDirection="column">
            <Heading
              color="neutral.700"
              size={{ base: 500, tablet: 700 }}
              width={{ base: '100%', tablet: '80%' }}
            >
              {post.title}
            </Heading>
            <Box
              width={{ base: '100%', tablet: '80%' }}
              mb={{ base: 400, tablet: 700 }}
            >
              <GatsbyImage
                alt={post.title}
                style={{
                  width: '100%',
                  backgroundSize: 'cover',
                  background: '#161e2f no-repeat center center',
                }}
                fluid={post.heroImage.fluid}
              />
            </Box>
            <BlogPostParser html={post.body.childMarkdownRemark.html} />
          </Box>
        </Box>
        <Box
          mt={{ base: 800, tablet: 0 }}
          display={{ base: 'flex', tablet: 'none' }}
          w="100%"
          alignItems="center"
          justifyContent="center"
        >
          <BlogPostShareButtons />
        </Box>
      </Box>
    </Container>
  );
};

BlogPost.defaultProps = {
  pb: 0,
  pt: 0,
};

export default BlogPost;
